export default __webpack_public_path__ + "static/media/ProjectDetails.b3a7bef8.svg";